import { render, staticRenderFns } from "./ClientSummary.vue?vue&type=template&id=efaa9de4"
import script from "./ClientSummary.vue?vue&type=script&lang=js"
export * from "./ClientSummary.vue?vue&type=script&lang=js"
import style0 from "./ClientSummary.vue?vue&type=style&index=0&id=efaa9de4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports